import React from 'react';
import '../styles/logo.css';
import { CONSTANTS } from '../../constants/constants';

const logo = () => {
  return (
    <div className="logo-container">
      <div className="logo-div">
        <div
          className="logoInflo"
          style={{ textAlign: 'center', lineHeight: 3, paddingLeft: 0, marginBottom: 36 }}
        >
          <img src={CONSTANTS.swalLogo} alt="logo" height='80px' />
        </div>
      </div>
    </div>
  );
};

export default logo;
